<template>
  <v-container fluid fill-height grid-list-lg>
    <v-layout row wrap align-content-start>
      <div style="width: 100%" v-if="showConfirmAlert">
        <v-alert :value="true" type="info" outlined>{{ $t('vendors.rejected.infoSavedWaitingForApproval') }}</v-alert>
      </div>

      <h3 v-if="imagesLoaded && rejectedImages.length <= 0">{{ $t('vendors.rejected.nonRejectedImages') }}</h3>
      <v-flex d-flex xs12 sm6 md4 lg2 v-for="image in rejectedImages" :key="image.id">
        <v-card v-on:click="imageClick(image)" class="thumb-image">
          <v-img contain :src="getThumbnailPath(image)" height="200px">
            <v-icon class="rejected">mdi-close-circle-outline</v-icon>
            <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
              <v-progress-circular indeterminate color="grey"></v-progress-circular>
            </v-layout>
          </v-img>

          <v-card-actions class="card-action">
            <span class="card-action-tag-item">
              <v-icon>mdi-tag</v-icon>
              {{ image.tags.length }}
            </span>
            <span class="card-action-category-item">
              <v-icon>mdi-layers</v-icon>
              {{
                image.categories.length === 0 ? $t('vendors.rejected.categoryMissing') : pickLocaleDescriptionValue(image.categories[0])
              }}
            </span>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <image-edit-dialog-component
      :visible="showImageDialog"
      :image="selectedImage"
      @updated="onImageUpdated"
      @deleted="onImageDeleted"
      @close="showImageDialog = false"
    ></image-edit-dialog-component>
  </v-container>
</template>

<script>
import { FileService } from '../../../services/file.service';
import ImageEditDialogComponent from '../../../components/dialog/ImageEditDialogComponent.vue';
import { pickLocaleDescription } from '../../../services/locale.service';

export default {
  components: {
    ImageEditDialogComponent,
  },

  data() {
    return {
      rejectedImages: [],
      imagesLoaded: false,
      selectedImage: undefined,
      showImageDialog: false,
      showConfirmAlert: false,
    };
  },

  methods: {
    pickLocaleDescriptionValue(item) {
      return pickLocaleDescription(item)
    },

    getThumbnailPath(image) {
      return `${image.path}/thumb/thumb_sm_${image.thumb_name.substring(6)}`;
    },

    reload() {
      new FileService().getRejected().then((data) => {
        this.imagesLoaded = true;
        this.rejectedImages = data.data;
      });
    },

    imageClick(image) {
      this.selectedImage = image;
      this.showImageDialog = true;
    },

    onImageDeleted() {
      const selectedImageIndex = this.rejectedImages.indexOf(this.selectedImage);
      this.rejectedImages.splice(selectedImageIndex, 1);
    },

    onImageUpdated(updatedImage) {
      const selectedImageIndex = this.rejectedImages.indexOf(this.selectedImage);
      this.rejectedImages.splice(selectedImageIndex, 1);
      this.showConfirmAlert = true;
      setTimeout(() => {
        this.showConfirmAlert = false;
      }, 5000);
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin: 20px 0;
}

i.rejected {
  width: 100%;
  color: red;
  font-size: 60px;
  justify-content: flex-end;
}

.thumb-image:hover {
  border: 1px solid black;
  cursor: pointer;
}
</style>
